import $ from 'jquery'

export default class Sort {
  constructor() {
    this.elm = document.querySelector('html')
  }

  init() {
    this.sortAccordion()
  }

  sortAccordion() {

    if ($('.c-sortBox__itemParent > .c-sortBox__link').hasClass('is-active')){
      if (window.matchMedia( "(max-width: 992px)" ).matches) {
        var active = $('.c-sortBox__itemParent > .c-sortBox__link.is-active');
        active.next('.c-sortBox__mark').find('i').removeClass('c-ico--chevronDown');
        active.next('.c-sortBox__mark').find('i').addClass('c-ico--chevronTop');
        active.next().next('.c-sortBox__listChild').css('display','block');
      }
    };

    $('.c-sortBox__toggle').on('click', function(){
      if ($('.c-sortBox__row').is(':visible')){
        $(this).find('i').removeClass('c-ico--chevronTop');
        $(this).find('i').addClass('c-ico--chevronDown');
      }else{
        $(this).find('i').removeClass('c-ico--chevronDown');
        $(this).find('i').addClass('c-ico--chevronTop');
      }
      $('.c-sortBox__row').slideToggle();
    })

    $('.c-sortBox__mark').on('click', function(){
      var listItem = $(this).parent().find('.c-sortBox__listChild');
      var iconChild = $(this).find('i');
      if (listItem.is(':visible')){
        iconChild.removeClass('c-ico--chevronTop');
        iconChild.addClass('c-ico--chevronDown');
      }else{
        iconChild.removeClass('c-ico--chevronDown');
        iconChild.addClass('c-ico--chevronTop');
      }
      listItem.slideToggle();
    });
  }
}
